import Link from 'next/link'

import { useNotification } from '@/containers'
import ImageOptimize from '../ImageOptimize'

export const HeaderLogo = () => {
  const { systemConfig } = useNotification()

  
return (
    <Link className='mx-auto flex h-[78px] w-auto justify-center' href={'/'}>
      {systemConfig?.warehouseLogo && (
        <ImageOptimize
          quality={100}
          className='h-full max-h-[80%] w-auto object-contain lg:max-h-full'
          alt={'Điện máy kho'}
          src={systemConfig?.warehouseLogo || ''}
          priority={true}
          loading='eager'
        />
      )}
    </Link>
  )
}
